import * as Yup from 'yup';

export const passwordValidation = Yup.string()
  .required('Povinné pole')
  .min(8, 'Heslo musí mít minimálně 8 znaků')
  .matches(/[A-Z]/, 'Heslo musí obsahovat alespoň jedno velké písmeno')
  .matches(/[a-z]/, 'Heslo musí obsahovat alespoň jedno malé písmeno')
  .matches(/\d/, 'Heslo musí obsahovat alespoň jednu číslici');

/**
 * Validace pro potvrzovací heslo, které se musí shodovat s původním heslem
 * @param {Yup.Ref} passwordRef - Reference na pole s heslem
 */
export const passwordConfirmValidation = (
  passwordRef: ReturnType<typeof Yup.ref>
): Yup.StringSchema =>
  Yup.string().oneOf([passwordRef, null], 'Hesla se musí shodovat!').required('Povinné pole');
